import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";
import chevronRightCircle from "../../img/experience/chevron-right-circle.svg";
import chevronDownCircle from "../../img/experience/chevron-down-circle.svg";

const TOOLS = [
  { titleKey: "exp.tools.t1.title", descKey: "exp.tools.t1.desc" },
  { titleKey: "exp.tools.t2", descKey: "exp.tools.t2.desc" },
  { titleKey: "exp.tools.t3", descKey: "exp.tools.t3.desc" },
  { titleKey: "exp.tools.t4", descKey: "exp.tools.t4.desc" },
];

function Tools() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col xl:flex-row xl:items-start gap-[40px] xl:gap-[116px]">
        {/* Left: heading + desc + button */}
        <div className="flex flex-col justify-between xl:h-[483px] xl:w-[504px] xl:shrink-0 gap-[40px] xl:gap-0">
          <div className="flex flex-col gap-[20px] xl:gap-[40px]">
            <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
              {t("exp.tools.title")}
            </h2>
            <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
              {t("exp.tools.desc")}
            </p>
          </div>
          <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
        </div>

        {/* Right: feature list */}
        <div className="flex flex-col flex-1">
          {TOOLS.map((tool, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i}>
                <div
                  className="flex flex-col gap-[6px] py-[16px] xl:py-0 xl:mb-[20px] cursor-my xl:mt-[20px]"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-['Montserrat'] font-semibold text-[16px] xl:text-[20px] text-[#020202] leading-normal">
                      {t(tool.titleKey)}
                    </span>
                    <div className="shrink-0 size-[30px] xl:size-[56px]">
                      {isOpen ? (
                        <img src={chevronDownCircle} alt="" aria-hidden className="w-full h-full rotate-90" />
                      ) : (
                        <img src={chevronRightCircle} alt="" aria-hidden className="w-full h-full" />
                      )}
                    </div>
                  </div>
                  {isOpen && (
                    <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[497px]">
                      {t(tool.descKey)}
                    </p>
                  )}
                </div>
                {i < TOOLS.length - 1 && <div className="h-[1px] bg-[#ebebeb]" />}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Tools;
